const ajax = require('sma.common/ajax');
const Grid = require('sma.admin/components/grid');
const Dropdown = require('sma.admin/components/dropdowns/dropdown');
const modals = require('sma.common/components/modals');
const SubmitConfirm = require('sma.applicant/confirm_submit_modal');
const Alert = require('sma.admin/components/alert.js');
const ApplicantDecisionModal = require('sma.applicant/components/decision');


const awardedTempl = require('sma.applicant/application/partials/decision.mustache');
const collaboratorTempl = require('sma.applicant/application/partials/collaborators.mustache');
const orgApplicantsTempl = require('sma.applicant/application/partials/org_applicants.mustache');
const orgTeamsTempl = require('sma.applicant/application/partials/org_team.mustache');
const reviewHeaderTempl = require('sma.applicant/application/partials/review_header.mustache');

const STRINGS = {
	deadline: gettext('Deadline'),
	start: gettext('Start'),
	completed_on: gettext('Completed on'),
	last_edited: gettext('Last edited'),
	continue: gettext('Continue'),
	optional: gettext('optional'),
	rename: gettext('Rename'),
	download: gettext('Download'),
	instructions: gettext('Instructions'),
	you_have_been_awarded: gettext('You have been awarded: '),
	declined: gettext('Declined'),
	awarded: gettext('Awarded'),
	decision_title: gettext('A decision has been made on your application'),
	name_application: gettext('Name your application'),
	rename_application: gettext('Rename your application'),
	delete_app: gettext('Delete'),
	delete_application: gettext('Delete your application'),
	delete_confirm: gettext('Are you sure you want to delete your application?\
		You won\'t be able to undo this action'),
	withdraw: gettext('Withdraw'),
	withdraw_application: gettext('Withdraw your application'),
	withdraw_confirm: gettext('Are you sure you want to withdraw your application?\
		You won\'t be able to undo this action'),
	collaborators: gettext('Collaborators'),
	invite_collaborators: gettext('Invite Collaborators'),
	owner: gettext('Owner'),
	add: gettext('Add'),
	invitation_pending: gettext('Invitation pending'),
	add_collaborator: gettext('Add collaborator'),
	remove: gettext('Remove'),
	change_access: gettext('Change access'),
	make_owner: gettext('Make owner'),
	invited: gettext('Invited:'),
	resend_invite: gettext('Resend invite'),
	score: gettext('Score'),
	performAction: gettext('Perform action on:'),
};

class ApplicationDetailView extends Backbone.View {
	get events() {
		return {
			'click .sma-js-applicant-collaborators': 'collaborators',
			'click .sma-js-applicant-stage-instructions': 'instructions',
			'click .sma-js-application-decision': 'decisionInfo',
			'click .sma-js-change-collaborator-access': 'changeCollaboratorAccess',
			'click .sma-js-make-owner': 'makeOwner',
			'click .sma-js-remove-collaborator': 'removeCollaborator',
			'click .sma-js-remove-team': 'removeTeam',
			'click .sma-js-resend-collaborator-invite': 'resendInvite',
			'click .sma-js-review-preview': 'previewReview',
			'click .sma-js-org-applicant-add': 'addOrgCollaborator',
			'click .sma-js-applicant-decision-accept': 'showApplicationDecisionModal',
			'click .sma-js-applicant-decision-decline': 'showApplicationDecisionModal',
			'click .sma-js-application-submit-button': 'showApplicationSubmitModal',
		};
	}

	get $actionMenu() {
		return $('.sma-js-applicant-application-menu');
	}

	constructor(config) {
		super();

		this.submission = config.submission;
		this.isOwner = config.isOwner;
		this.applicantStages = config.applicantStages;

		this.setElement($('body'));

		this.render();
	}

	render() {
		this.renderActionMenu();
		this.renderApplicantsMenu();
		this.renderReviews();
	}

	get $collaboratorContainer() {
		return this.$el.find('.sma-js-collaborator-container');
	}

	get $organizationContainer() {
		return this.$el.find('.sma-js-org-member-container');
	}

	renderApplicantsMenu() {
		if (!this.submission.is_owned_by_org) {
			this.renderCollaboratorMenu();
		} else {
			this.renderOrganizationMenu();
		}
	}

	renderActionMenu() {
		let items = [{
			name: 'download',
			text: STRINGS.download,
			ariaLabel: 'Download (opens in a new tab)',
			action: (data) => {
				let config = {
					download_format: 'as_merged_applications',
					stage_ids: this.applicantStages,
					submission_ids: [this.submission.id],
					include_application_profiles: true,
				};

				ajax.post({
					url: reverse('download-redirect'),
					alertOnSuccess: false,
					data: config,
					callback: (response) => {
						if (response.url) window.open(response.url, "_blank");
					}
				});
			}
		}];

		if (this.submission.can_rename && !this.submission.is_withdrawn) {
			items.unshift({
				name: 'rename',
				text: STRINGS.rename,
				action: (data) => { this.renameDialog(); }
			});
		}

		if (this.submission.can_delete && this.isOwner) {
			items.push({
				name: 'delete',
				text: STRINGS.delete_app,
				action: (data) => {
					new modals.Confirm(
						STRINGS.delete_application,
						STRINGS.delete_confirm,
						() => {
							ajax.post({
								url: reverse('application-delete', { app_id: this.submission.id }),
								callback: (response) => {
									window.location.href = reverse('application-dashboard');
								}
							});
						},
					);
				}
			});
		}

		let dropdown = new Dropdown({
			items: items,
			title: '<i class="nc-icon-mini ui-2_menu-dots" aria-hidden="true"></i>',
			noCaret: true,
			btnclass: 'js-sma-leftnav btn-link btn-crammed',
			rightAligned: true,
			ariaLabel: interpolate(gettext('Perform action on application: %(appName)s'), { appName: this.submission.title }, true)
		}).$el.addClass('dropdown');

		this.$actionMenu.html(dropdown);
	}

	renderCollaboratorMenu() {
		let url = reverse('get-collaborator-list', { app_id: this.submission.id });

		let options = {
			url: url,
			callback: $.proxy(function (response) {
				let owner = response.owner;
				let collaborators = response.collaborators;
				let hasCollaborators = collaborators.length;
				let canEdit = response.can_edit;
				let isOwner = response.is_owner;

				this.$collaboratorContainer.html(collaboratorTempl({
					owner: owner,
					isOwner: isOwner,
					collaborators: collaborators,
					hasCollaborators: hasCollaborators,
					canEdit: canEdit,
					strings: STRINGS,
				}))
			}, this)
		};

		ajax.get(options);
	}

	renderOrganizationMenu() {
		let url = reverse('get-org-applicant-list', { app_id: this.submission.id });

		let options = {
			url: url,
			callback: $.proxy(function (response) {
				this.$organizationContainer.html(orgApplicantsTempl({
					collaborators: response.applicants.individuals,
					canEdit: response.can_edit,
					strings: STRINGS,
				}));

				let members = '';

				for (var team of response.applicants.teams) {
					members = orgApplicantsTempl({
						collaborators: team.members,
						canEdit: response.can_edit,
						strings: STRINGS,
					});
					this.$organizationContainer.append(orgTeamsTempl({
						team: team,
						members: members,
						canEdit: response.can_edit,
						strings: STRINGS
					}));
				}
			}, this)
		};

		ajax.get(options);
	}

	renderReviews() {
		if (!this.submission.can_see_reviews) return;

		for (var round of this.submission.reviews) {
			let hiddenColumns = [];

			if (!round.can_see_score) {
				hiddenColumns = ['score'];
			}

			let grid = new ReviewGrid({
				element: $(`#sma-js-applicant-reviews-${round.id}`),
				hiddenColumns: hiddenColumns,
				results: {
					count: round.reviewers.length,
					results: round.reviewers
				}
			});

			grid.buildVisibleColumns();
			grid.renderColumnHeaders();
		}
	}

	renderVideoElements() {
		setTimeout(function () {
			$('.form-video-element').each(function () {

				console.log("working");
				const that = $(this);

				const regex = /\{\{\s*(\w+):([\w\-]+):(\d+):(\d+)\s*\}\}/;

				const matches = that.text().match(regex);

				if (matches) {
					const platform = matches[1];
					const id = matches[2];
					const width = matches[3];
					const height = matches[4];
					let video_url = `https://www.youtube.com/embed/${id}`;

					if (platform === 'Vimeo') {
						video_url = `https://player.vimeo.com/video/${id}`;
					}
					that.parent().parent().html(`<iframe frameBorder="0" width="${width}" height="${height}" src="${video_url}" ></iframe>`);
				}
			})
		}, 200)

	}

	collaborators(e) {
		e.preventDefault();

		let that = this;

		let modal = new modals.AjaxFormModal({
			destroyOnClose: true,
			size: 'lg',
			title: STRINGS.invite_collaborators,
			onSuccess: function (response) {
				this.hide();
				new Alert({
					type: 'success',
					message: gettext('Collaborator invitation successfully sent.'),
				});
				that.renderCollaboratorMenu();
			},
		});

		modal.addToStack(
			'AddCollaborators',
			new modals.AjaxFormContent(
				reverse('get-collaborators', {
					app_id: this.submission.id,
				}), {
				destroyOnClose: true,
				onLoad: () => { modal.show(); },
				title: STRINGS.collaborators,
				buttons: [{
					label: gettext('Send Invite'),
					cls: 'btn btn-primary btn-loud sma-js-collaborator-invite',
					form: 'addCollaboratorForm',
					type: 'submit',
					handler: (modal) => { }
				}]
			}
			)
		);

		modal.show();
		this.renderVideoElements();
	}

	addOrgCollaborator(e) {
		e.preventDefault();

		let org_applicants_url = reverse('get-org-member-list', { app_id: this.submission.id });

		let modal = new modals.ContentModal('<div class="sma-js-member-grid"></div>', {
			title: gettext('Add members to application'),
			destroyOnClose: true,
			autoShow: true,
			buttons: [
				{
					label: gettext('CANCEL'),
					cls: 'btn btn-link',
					handler: (modal) => {
						modal.hide();
					}
				}, {
					label: gettext('ADD'),
					cls: 'btn btn-primary',
					handler: (modal) => {
						let selected = this.memberGrid.selectedRows;

						let users = selected
							.filter(item => { return item.is_user })
							.map(item => { return item.user__id });

						let teams = selected
							.filter(item => { return !item.is_user })
							.map(item => { return item.id });

						ajax.post({
							url: org_applicants_url,
							data: { users, teams },
							callback: (response) => {
								this.renderApplicantsMenu();
								modal.hide();
							}
						});
					}
				}
			]
		});

		this.memberGrid = new OrgMemberGrid({
			element: $('.sma-js-member-grid'),
			url: org_applicants_url
		});
	}

	changeCollaboratorAccess(e) {
		e.preventDefault()
		let target = $(e.currentTarget);

		let memberId = target.data('member-id');

		let url = reverse('change-collaborator-access', {
			app_id: this.submission.id,
			member_id: memberId
		})

		let options = {
			url: url,
			callback: (response) => {
				this.renderApplicantsMenu();
			}
		}

		ajax.post(options);
	}


	makeOwner(e) {
		e.preventDefault()
		let target = $(e.currentTarget);

		let memberId = target.data('member-id');

		let url = reverse('make-collaborator-owner', {
			app_id: this.submission.id,
			member_id: memberId
		})

		let options = {
			url: url,
			callback: (response) => {
				this.renderApplicantsMenu();
			}
		}

		ajax.post(options);
	}

	resendInvite(e) {
		e.preventDefault()
		let target = $(e.currentTarget);

		let memberId = target.data('member-id');

		let url = reverse('resend-collaborator-invite', {
			app_id: this.submission.id,
			member_id: memberId
		})

		let options = {
			url: url,
			callback: (response) => {
				this.renderApplicantsMenu();
			}
		}

		ajax.post(options);
	}

	removeCollaborator(e) {
		e.preventDefault()
		let target = $(e.currentTarget);

		let memberId = target.data('member-id');

		let url = reverse('remove-collaborator', {
			app_id: this.submission.id,
			member_id: memberId
		})

		let options = {
			url: url,
			callback: (response) => {
				if (response.return_url) {
					window.location.href = response.return_url;
					return;
				}
				this.renderApplicantsMenu();
			}
		}
		new modals.Confirm(
			gettext('Remove collaborator'),
			gettext('Are you sure that you want to remove this collaborator?'),
			() => {
				ajax.post(options);
			},
		);
	}

	removeTeam(e) {
		e.preventDefault()

		let url = reverse('remove-team', {
			app_id: this.submission.id,
			team_id: $(e.currentTarget).data('team-id')
		})

		let options = {
			url: url,
			callback: (response) => {
				this.renderApplicantsMenu();
			}
		};

		new modals.Confirm(
			gettext('Remove team'),
			gettext('Are you sure that you want to remove this team?'),
			() => {
				ajax.post(options);
			},
		);
	}

	instructions(e) {
		e.preventDefault();

		let url = reverse('application-instructions', { app_id: this.submission.id });

		new modals.URLModal(url, {
			autoShow: true,
			title: STRINGS.instructions,
		});
	}

	decisionInfo(e) {
		e.preventDefault();

		let content = awardedTempl({
			submission: this.submission,
			strings: STRINGS
		});

		let config = {
			autoShow: true,
			destroyOnClose: true,
			title: STRINGS.decision_title,
		};

		new modals.ContentModal(content, config);
	}

	renameDialog() {
		new modals.Prompt(
			STRINGS.rename_application,
			this.submission.award.naming_instructions,
			(name) => {
				ajax.post({
					url: reverse('application-rename', { app_id: this.submission.id }),
					data: { new_title: name },
					callback: (response) => {
						$('.sma-js-applicant-application-title').text(name);
					}
				})
			}, {
			maxLength: 75
		}
		);
	}

	previewReview(e) {
		e.preventDefault();

		let target = $(e.currentTarget).data('review-id');

		let url = reverse('submission-taskrecord-preview', {
			submission_id: this.submission.id,
			task_record_id: target,
		});

		url += "?no_task_header=1";

		let context = {
			reviewer: $('tr[name="' + target + '"] td[role="reviewer"]').html(),
			score: $('tr[name="' + target + '"] td[role="score"]').html(),
			strings: STRINGS
		};

		new modals.AjaxURLModal(url, {
			autoShow: true,
			size: 'lg',
			destroyOnClose: true,
			bodyClass: 'sma-reviewer-modal',
			headerTemplate: reviewHeaderTempl,
			headerContext: context
		});
	}

	showApplicationDecisionModal() {
		new ApplicantDecisionModal(
			{
				title: gettext('You have been awarded!'),
				size: 'md',
				bodyClass: 'sma-applicant-decision-modal-wrapper',
				autoShow: true,
				$decisionCallout: $('.sma-applicant-decision-callout'),
			},
			{
				submission: this.submission,
			},
		);
	}

	showApplicationSubmitModal(e) {
		e.preventDefault();

		new SubmitConfirm({ appId: this.submission.id });
	}
}

let ReviewGrid = Grid.Grid.extend({
	columns: [
		{
			id: 'reviewer',
			name: 'Reviewer',
			formatter: function (item, grid) {
				if (item.photo) {
					return `<img class="sma-avatar-sm" src=${item.photo}/> ${item.reviewer}`
				}
				return `<span class="sma-avatar-sm">
					${item.initials}</span> ${item.reviewer}`;
			}
		}, {
			id: 'score',
			name: 'Score',
			formatter: function (item, grid) {
				if (item.score == null) { return "" };

				return `${item.score ? item.score : ""}%`;
			}
		}, {
			id: 'preview',
			name: '',
			formatter: function (item, grid) {
				if (!item.id) return '';
				return `<a href="#" class="sma-js-review-preview" data-review-id="${item.id}">
					<i class="nc-icon-mini ui-3_filter-check" aria-hidden="true"></i></a>`;
			}
		}
	],
	showTitlebar: false,
	showSearchBar: false,
	showFooter: false,
	showColumnDropSelect: false,
	showSelectorColumn: false,
});

let OrgMemberGrid = Grid.Grid.extend({
	columns: [{
		id: 'member',
		name: gettext('Members & teams'),
		formatter: function (item, grid) {
			let box = item.is_user ? item.initials : '<i class="nc-icon-glyph users-2_meeting"></i>';
			let subtext = item.is_user ? item.user__email : interpolate(
				ngettext('%s member', '%s members', item.member_count),
				[item.member_count]
			);

			return `<div class="sma-profile-icon-group">
				<div class="sma-avatar-sm">${box}</div>
				<div style="display:inline-block" class="sma-avatar-user">
					<div class="sma-avatar-name">${item.name}</div>
					<small class="sma-avatar-email text-muted">${subtext}</small>
				</div>
			</div>`;
		}
	}],
	intID: false,
	orderCols: ['member'],
	showTitlebar: false,
	showSearchBar: true,
	showFooter: false,
	showColumnDropSelect: false,
});

module.exports = {
	ApplicationDetailView: ApplicationDetailView
};
